/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../deposits/bank_account_service';
import './plaid_linking_models';
import '../transfer_common/client_capable_flow';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "bank_account": {
                "nested": {
                  "CreatePlaidLinkSessionRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CreatePlaidLinkSessionSubmission": {
                        "fields": {
                          "stepIdentifier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "copyToken": {
                            "type": "string",
                            "id": 2
                          },
                          "consent": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.ConsentSubmission",
                            "id": 3
                          },
                          "multiBankConsent": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.MultiBankConsentSubmission",
                            "id": 4
                          }
                        },
                        "nested": {
                          "submission": {
                            "oneof": ["copyToken", "consent", "multiBankConsent"]
                          }
                        }
                      },
                      "ConsentSubmission": {
                        "fields": {
                          "copyToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountHolderRelationshipToBusiness": {
                            "type": ".squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "MultiBankConsentSubmission": {
                        "fields": {
                          "copyToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountHolderRelationshipToBusiness": {
                            "type": ".squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "CreatePlaidLinkSessionResponse": {
                    "fields": {
                      "step": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionStep",
                        "id": 1
                      },
                      "session": {
                        "type": ".squareup.bbfrontend.common.bank_account.PlaidLinkSession",
                        "id": 2
                      },
                      "submissionError": {
                        "type": "string",
                        "id": 3
                      }
                    },
                    "nested": {
                      "result": {
                        "oneof": ["step", "session", "submissionError"]
                      }
                    }
                  },
                  "CreateAndLinkBankAccountFromPlaidLinkRequest": {
                    "fields": {
                      "plaidLinkSessionResults": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountHolderRelationshipToBusiness": {
                        "type": ".squareup.deposits.bank_account_service.AccountHolderRelationshipToBusiness",
                        "id": 3,
                        "rule": "optional"
                      },
                      "step": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep",
                        "id": 4,
                        "rule": "optional"
                      },
                      "entryPoint": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkEntryPoint",
                        "id": 5,
                        "rule": "optional"
                      },
                      "directDebitMandateIdempotenceKey": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission",
                        "id": 7,
                        "rule": "optional"
                      },
                      "context": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.Context",
                        "id": 8,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Context": {
                        "values": {
                          "UNKNOWN": 0,
                          "LINK_BANK_ACCOUNT": 1,
                          "LINK_BANK_THEN_DEBIT_CARD_IF_NECESSARY": 2
                        }
                      },
                      "CreateAndLinkBankAccountFromPlaidLinkStep": {
                        "values": {
                          "CREATE_AND_LINK_FROM_PLAID_STEP_UNKNOWN": 0,
                          "INITIALIZE": 1,
                          "CONFIRM_DIRECT_DEBIT_MANDATE": 2,
                          "SELECT_BANK_ACCOUNT": 3
                        }
                      },
                      "CreateAndLinkBankAccountFromPlaidLinkEntryPoint": {
                        "values": {
                          "CREATE_AND_LINK_FROM_PLAID_ENTRY_POINT_UNKNOWN": 0,
                          "BANK_ACCOUNT_SETTINGS": 1,
                          "TRANSFER_SETTINGS": 2
                        }
                      },
                      "PlaidLinkSessionResults": {
                        "fields": {
                          "sessionToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "context": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.Context",
                            "id": 2,
                            "rule": "optional"
                          },
                          "plaidPublicToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "selectedPlaidBankAccountId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "bankName": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "bankAccountNumberMask": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "bankAccountName": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "singleSelection": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.SingleBankAccountSelection",
                            "id": 8
                          },
                          "multipleSelection": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.MultipleBankAccountSelection",
                            "id": 9
                          }
                        },
                        "nested": {
                          "SingleBankAccountSelection": {
                            "fields": {
                              "selectedPlaidBankAccountId": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "MultipleBankAccountSelection": {
                            "fields": {
                              "selectedPlaidBankAccountIds": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "plaid_bank_account_selection": {
                            "oneof": ["singleSelection", "multipleSelection"]
                          }
                        }
                      },
                      "CreateAndLinkBankAccountFromPlaidLinkSubmission": {
                        "fields": {
                          "stepIdentifier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "bankAccount": {
                            "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission.BankAccountSelectionSubmission",
                            "id": 2
                          }
                        },
                        "nested": {
                          "BankAccountSelectionSubmission": {
                            "fields": {
                              "bankAccountToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "submission": {
                            "oneof": ["bankAccount"]
                          }
                        }
                      }
                    }
                  },
                  "CreateAndLinkBankAccountFromPlaidLinkResponse": {
                    "fields": {
                      "clientFlow": {
                        "type": ".squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow",
                        "id": 2
                      },
                      "resultStep": {
                        "type": ".squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkSessionStep",
                        "id": 3
                      }
                    },
                    "nested": {
                      "result": {
                        "oneof": ["clientFlow", "resultStep"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionRequest?.nested?.CreatePlaidLinkSessionSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionRequest?.nested?.ConsentSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionRequest?.nested?.MultiBankConsentSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreatePlaidLinkSessionResponse && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.Context && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.CreateAndLinkBankAccountFromPlaidLinkStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.CreateAndLinkBankAccountFromPlaidLinkEntryPoint && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.PlaidLinkSessionResults && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.PlaidLinkSessionResults?.nested?.SingleBankAccountSelection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.PlaidLinkSessionResults?.nested?.MultipleBankAccountSelection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.CreateAndLinkBankAccountFromPlaidLinkSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkRequest?.nested?.CreateAndLinkBankAccountFromPlaidLinkSubmission?.nested?.BankAccountSelectionSubmission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.bank_account?.nested?.CreateAndLinkBankAccountFromPlaidLinkResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreatePlaidLinkSessionRequest @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 15:1
 */
export const CreatePlaidLinkSessionRequest = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest');
fixType(CreatePlaidLinkSessionRequest, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionRequest);
/**
 * SOURCE CreatePlaidLinkSessionSubmission @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 16:3
 */
CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission');
fixType(CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission, {
  stepIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionRequest.CreatePlaidLinkSessionSubmission);
/**
 * SOURCE ConsentSubmission @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 33:3
 */
CreatePlaidLinkSessionRequest.ConsentSubmission = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.ConsentSubmission');
fixType(CreatePlaidLinkSessionRequest.ConsentSubmission, {
  copyToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionRequest.ConsentSubmission);
/**
 * SOURCE MultiBankConsentSubmission @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 38:3
 */
CreatePlaidLinkSessionRequest.MultiBankConsentSubmission = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest.MultiBankConsentSubmission');
fixType(CreatePlaidLinkSessionRequest.MultiBankConsentSubmission, {
  copyToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkSessionRequest.MultiBankConsentSubmission);
/**
 * SOURCE CreatePlaidLinkSessionResponse @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 44:1
 */
export const CreatePlaidLinkSessionResponse = $root.lookupType('squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionResponse');
fixType(CreatePlaidLinkSessionResponse);
Builder.createAndAttachToType(CreatePlaidLinkSessionResponse);
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkRequest @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 52:1
 */
export const CreateAndLinkBankAccountFromPlaidLinkRequest = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest, {
  unitToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest);
/**
 * SOURCE Context @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 53:3
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.Context = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.Context').values;
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkStep @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 59:3
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkStep').values;
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkEntryPoint @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 66:3
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkEntryPoint = $root.lookupEnum('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkEntryPoint').values;
/**
 * SOURCE PlaidLinkSessionResults @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 72:3
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults, {
  sessionToken: {
    notEmpty: true
  },
  context: {
    required: true
  },
  plaidPublicToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults);
/**
 * a bank account selected as the result of a Plaid session that only allows a single bank
 * account to be selected. If a session allowing multiple accounts yields a single bank account
 * use MultipleBankAccountSelection
 *
 * SOURCE SingleBankAccountSelection @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 94:5
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.SingleBankAccountSelection = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.SingleBankAccountSelection');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.SingleBankAccountSelection, {
  selectedPlaidBankAccountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.SingleBankAccountSelection);
/**
 * bank account(s) selected as the result of a Plaid session that allows multiple bank accounts
 * to be selected
 *
 * SOURCE MultipleBankAccountSelection @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 101:5
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.MultipleBankAccountSelection = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.MultipleBankAccountSelection');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.MultipleBankAccountSelection, {
  selectedPlaidBankAccountIds: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest.PlaidLinkSessionResults.MultipleBankAccountSelection);
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkSubmission @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 128:3
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission, {
  stepIdentifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission);
/**
 * SOURCE BankAccountSelectionSubmission @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 129:5
 */
CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission.BankAccountSelectionSubmission = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission.BankAccountSelectionSubmission');
fixType(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission.BankAccountSelectionSubmission, {
  bankAccountToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkRequest.CreateAndLinkBankAccountFromPlaidLinkSubmission.BankAccountSelectionSubmission);
/**
 * SOURCE CreateAndLinkBankAccountFromPlaidLinkResponse @ squareup/bbfrontend/common/bank_account/bank_account_service.proto at 144:1
 */
export const CreateAndLinkBankAccountFromPlaidLinkResponse = $root.lookupType('squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkResponse');
fixType(CreateAndLinkBankAccountFromPlaidLinkResponse);
Builder.createAndAttachToType(CreateAndLinkBankAccountFromPlaidLinkResponse);